import type { ReactNode, SVGProps } from "react";

export function TeamManagementIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="-1.875 -1.875 17 17"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.9585 3.29167C1.9585 3.99891 2.23945 4.67719 2.73954 5.17729C3.23964 5.67738 3.91792 5.95833 4.62516 5.95833C5.33241 5.95833 6.01068 5.67738 6.51078 5.17729C7.01088 4.67719 7.29183 3.99891 7.29183 3.29167C7.29183 2.58442 7.01088 1.90615 6.51078 1.40605C6.01068 0.905951 5.33241 0.625 4.62516 0.625C3.91792 0.625 3.23964 0.905951 2.73954 1.40605C2.23945 1.90615 1.9585 2.58442 1.9585 3.29167Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 12.625V11.2917C0.625 10.5844 0.905951 9.90615 1.40605 9.40605C1.90615 8.90595 2.58442 8.625 3.29167 8.625H5.95833C6.66558 8.625 7.34385 8.90595 7.84395 9.40605C8.34405 9.90615 8.625 10.5844 8.625 11.2917V12.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M9.2915 0.711426C9.86511 0.858293 10.3735 1.19189 10.7366 1.65963C11.0997 2.12737 11.2967 2.70265 11.2967 3.29476C11.2967 3.88687 11.0997 4.46215 10.7366 4.92988C10.3735 5.39762 9.86511 5.73122 9.2915 5.87809"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M12.625 12.6251V11.2918C12.6216 10.7032 12.4236 10.1323 12.0618 9.66803C11.7001 9.20377 11.1949 8.87223 10.625 8.7251"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
